import { BBModel } from '../bb_model';
import { context } from './../constants/context';
import { halClient } from '../hal';

const queuer = {
    async queryByReference(reference) {
        const url = `${context.apiUrl}/api/${context.apiVersion}/queuers/${reference}`;
        return new BBModel.Queuer(await halClient.$get(url));
    }
};

export {
    queuer
};
